export default __webpack_public_path__ + "static/logo-cult-of-pigeons@2x-5bd83940a2874174288eb01dc5f0ddff.png";